import React from "react";
import { CollectionListItem, ICollectionListItem } from "../CollectionListItem/CollectionListItem";

interface ICollectionList {
    items: ICollectionListItem[];
}

export const CollectionList = ({ items }: ICollectionList) => {
    return (
        <div className="CollectionList">
            {items.map((item, i) => (
                <CollectionListItem key={item.displayDate + item.title + i} {...item} />
            ))}
        </div>
    );
};
